import DateRangeFilter from "../components/controls/DateRangeFilter.vue";
import MultipleSelectFilter from "../components/controls/MultipleSelectFilter.vue";

export default {
  install: Vue => {
    Vue.component("date-range-filter", DateRangeFilter);
    Vue.component("multiple-select-filter", MultipleSelectFilter);
  }
};
